import { Box, Typography, Stack, Skeleton } from '@mui/material';
import { FlexGrid, FlexGridColumn } from '@grapecity/wijmo.react.grid';
import { useTranslation } from 'react-i18next';
import 'views/public/Competitions/assets/publicGrid.css';
import { useQuery } from 'react-query';
import { apiEntities } from 'apis';
import { useNavigate, createSearchParams, useSearchParams } from 'react-router-dom';

const clubs = [
    {
        Code: 0,
        Title: 'Ελληνική Ομοσπονδία Ταεκβοντό',
        Abbr: 'ΕΛΟΤ',
        founded: 'NULL',
        url: 'https://elot-tkd.gr/',
        eMail: 'info@elot-tkd.gr'
    },
    { Code: 1029, Title: 'EOS IONION NISON ', Abbr: 'EOS IN', founded: 'NULL', eMail: 'eosin@gmail.com' },
    { Code: 1030, Title: 'Qubiteq IKE', Abbr: 'Qub', founded: '2023', url: 'https://qubiteq.gr/', eMail: 'test@test.gr' },
    { Code: 1039, Title: 'ΠΑΝΘΗΡΕΣ ΞΑΝΘΗΣ', Abbr: 'ΠΑΝΘΗΡΕΣ', founded: '2024', eMail: 'test@test.gr' },
    { Code: 1036, Title: 'ΚΕΦΑΛΛΗΝΙΑΚΟΣ ΑΣ', Abbr: 'ΚΕΦ ΑΣ', founded: '2018', url: 'www.kefalliniakos.gr' },
    { Code: 1035, Title: 'ΠΑΝΑΘΗΝΑΙΚΟΣ ΤΙΤΛΟΣ', Abbr: 'ΠΑΟ', founded: 'NULL', eMail: 'spc@hotech.gr' },
    { Code: 1031, Title: 'ΑΔΑΜΑΣ AO', Abbr: 'ΑΔΑΜ ΑO', founded: '1997', url: 'adamas.elot.gr', eMail: 'adamkalofonos@gmail.com' },
    { Code: 1038, Title: 'ΜΑΚΕΔΩΝΕΣ ΜΑΧΗΤΕΣ', Abbr: 'ΜΑΚ ΜΑΧ', founded: '2018' },
    { Code: 1034, Title: 'ΑΘΛΗΤΙΚΟΣ ΣΥΛΛΟΓΟΣ ΑΡΤΕΜΙΔΟΣ', Abbr: 'ΑΣΑ ', founded: '2018', eMail: 'artemida@mail.com' },
    { Code: 259, Title: 'ΑΘΛΗΤΙΚΟΣ ΓΥΜΝΑΣΤΙΚΟΣ ΣΥΛΛΟΓΟΣ ΠΑΛΜΟΣ', Abbr: 'ΑΓΣ ΠΑΛΜΟΣ', founded: 'NULL', eMail: 'palmos_tkd@hotmail.gr' },
    { Code: 1025, Title: 'ΠΑΡΜΕΝΙΩΝ ΣΧΙΣΤΟΥ', Abbr: 'ΠΑΣΧΗ', founded: 'NULL' },
    { Code: 1037, Title: 'Test 2', Abbr: 'T2', founded: 'NULL' },
    {
        Code: 243,
        Title: 'ΑΘΛΗΤΙΚΟ ΣΩΜΑΤΕΙΟ ΑΡΙΩΝ (Θεσσαλονίκη)',
        Abbr: 'ΑΘΛ. ΣΩΜ. ΑΡΙΩΝ',
        founded: '2022',
        eMail: 'ARIONAC@WINDOWSLIVE.COM'
    },
    { Code: 1021, Title: 'Τεστ_ILK', Abbr: 'TILK', founded: '2022', url: 'www.tilk.gr', eMail: 'ιλκ@κιουμπιτεκ.γρ' }
];

const ClubsGrid = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();

    const clubsQuery = useQuery(['competitions'], async () => {
        const res = clubs;
        return res;
    });

    const gridInitialized = (flex) => {
        flex.hostElement?.addEventListener('dblclick', async (e) => {
            e.preventDefault();
            e.stopPropagation();
            const ht = flex.hitTest(e.pageX, e.pageY);
            if (ht?.grid && ht.cellType === 1) {
                const rowNumber = ht.row;
                navigate({
                    pathname: `/public/competition`,
                    search: createSearchParams({ id: flex?.collectionView?.items[rowNumber]?.Id }).toString()
                });
            }
        });
    };

    console.log(clubsQuery);
    return {
        loading: <Skeleton sx={{ width: '100%', height: '8vh' }} />,
        success: (
            <Stack spacing={2} sx={{ width: '100%' }}>
                <Stack direction="row" spacing={1} justifyContent="fflex-start" alignItems="center">
                    <Box sx={{ width: '5px', height: '100%', background: '#4d79bc', borderRadius: 2 }} />
                    <Typography sx={{ fontSize: '30px', fontFamily: 'Inter' }}>{t('Calendar')}</Typography>
                </Stack>
                <FlexGrid
                    initialized={gridInitialized}
                    itemsSource={clubsQuery?.data}
                    selectionMode={0}
                    autoRowHeights
                    isReadOnly
                    headersVisibility={1}
                    className="public-grid"
                >
                    <FlexGridColumn header={t('Code')} binding="Code" width="1.5*" align="center" allowSorting={0} />
                    <FlexGridColumn header={t('Title')} binding="Title" width="*" />
                    <FlexGridColumn header={t('Abbr')} binding="Abbr" width="2*" wordWrap />
                    <FlexGridColumn header={t('FoundedAt')} binding="FoundedAt" width="1.5*" wordWrap />
                    <FlexGridColumn header={t('Url')} binding="url" width="2*" wordWrap />
                    <FlexGridColumn header={t('Email')} binding="eMail" width="1.5*" />
                </FlexGrid>
            </Stack>
        ),
        error: <Typography>Error...</Typography>
    }[clubsQuery.status];
};

export default ClubsGrid;
